import {ILLIQUID_OPTION_THRESHOLD, ViewType} from '../assets/constants'
import {optionTradeDataType} from '../pages/typings/options.typings'
import {TimeBucket, TimeBucket_TimeSeries} from '../proto/generated/common'
import {shortMonthNames} from './general'
import {Broker_OrderType} from '../proto/generated/order'
import StrategyBuilder from '../assets/icons/StrategyBuilder'
import OptionChain from '../assets/icons/OptionChain'
import Chart from '../assets/icons/Chart'
import IvPlots from '../assets/icons/IvPlots'

export const navItems = [
    // {
    //     key: ViewType.CHART,
    //     label: <Chart sx={{fontSize: "28px", strokeWidth: 1.25}}/>,
    //     tooltip: 'Chart',
    //     viewTypes: [ViewType.CHART, ViewType.SYMBOL] // alternate view types for same nav link
    // },
    // {
    //     key: ViewType.OPTION_CHAIN,
    //     label: <OptionChain sx={{fontSize: "28px", strokeWidth: 1.25}}/>,
    //     tooltip: 'Option Chain'
    // },
    // {
    //     key: ViewType.STRATEGY_BUILDER,
    //     label: <StrategyBuilder sx={{fontSize: "28px", strokeWidth: 1.25}}/>,
    //     tooltip: 'Strategy Builder'
    // },
    // {
    //     key: ViewType.MULTI_STRIKES_CHART,
    //     label: <IvPlots sx={{fontSize: "28px", strokeWidth: 1.25}}/>,
    //     tooltip: 'Multi Strike'
    // }
]
export const strikeValues = {
    values: [
        {value: '10', label: '10'},
        {value: '15', label: '15'},
        {value: '25', label: '25'},
        {value: 'all', label: 'All'}
    ], maxValue: 25
}

export const timeIntervalValues: { value: TimeBucket, label: string }[] = [
    {
        value: {
            timeSeries: TimeBucket_TimeSeries.MINUTE,
            value: 5
        },
        label: '5m'
    },
    {
        value: {
            timeSeries: TimeBucket_TimeSeries.MINUTE,
            value: 15
        },
        label: '15m'
    },
    {
        value: {
            timeSeries: TimeBucket_TimeSeries.HOUR,
            value: 1
        },
        label: '1h'
    },
    {
        value: {
            timeSeries: TimeBucket_TimeSeries.DAY,
            value: 1
        },
        label: '1d'
    }
]

export const isMarketOrder = (orderType: Broker_OrderType): boolean => {
    return [Broker_OrderType.MARKET_ORDER, Broker_OrderType.STOPLOSS_MARKET_ORDER].includes(orderType)
}

export const OI_RANK_SCALE = 80

export const calculateOiRanks = (trade: optionTradeDataType[], atmStrike: number) => {
    const minOi = Math.min(...trade.map((item) => item.callOption?.openInterest || 0), ...trade.map((item) => item.putOption?.openInterest || 0))
    const maxOi = Math.max(...trade.map((item) => item.callOption?.openInterest || 0), ...trade.map((item) => item.putOption?.openInterest || 0))

    const minOiChange = Math.min(
        ...trade.map((item) => Math.abs(item.callOption?.oiChanges?.oiChange?.change || 0)),
        ...trade.map((item) => Math.abs(item.putOption?.oiChanges?.oiChange?.change || 0))
    )
    const maxOiChange = Math.max(
        ...trade.map((item) => Math.abs(item.callOption?.oiChanges?.oiChange?.change || 0)),
        ...trade.map((item) => Math.abs(item.putOption?.oiChanges?.oiChange?.change || 0))
    )

    const maxAllowedPcrValue = 10
    for (let i = 0; i < trade.length; i++) {
        let item = trade[i]
        const rankCall = 1 + (((item.callOption?.openInterest || 0) - minOi) * OI_RANK_SCALE) / (maxOi - minOi)
        const rankPut = 1 + (((item.putOption?.openInterest || 0) - minOi) * OI_RANK_SCALE) / (maxOi - minOi)

        const oiChangeScoreCall = 1 + ((Math.abs(item.callOption?.oiChanges?.oiChange?.change || 0) - minOiChange) * OI_RANK_SCALE) / (maxOiChange - minOiChange)
        const oiChangeScorePut = 1 + ((Math.abs(item.putOption?.oiChanges?.oiChange?.change || 0) - minOiChange) * OI_RANK_SCALE) / (maxOiChange - minOiChange)

        // calculating illiquid option

        let callIlliquid = false
        let putIlliquid = false

        const callMid = ((item.callOption?.topBid ?? 0) + (item.callOption?.topAsk ?? 0)) / 2
        const putMid = ((item.putOption?.topBid ?? 0) + (item.putOption?.topAsk ?? 0)) / 2

        if (item.strikeCol.strike < atmStrike) {
            const callDiff = Math.abs((item.callOption?.topBid ?? 0) - (item.callOption?.topAsk ?? 0))
            const putDiff = Math.abs((item.putOption?.topBid ?? 0) - (item.putOption?.topAsk ?? 0))
            const callDiffPercent = (callDiff / callMid) * 100
            const putDiffPercent = (putDiff / putMid) * 100
            if (item.callOption?.topAsk === 0 || item.callOption?.topBid === 0 || (callDiffPercent > ILLIQUID_OPTION_THRESHOLD && callDiff > 100)) {
                callIlliquid = true
            }
            if (item.putOption?.topAsk === 0 || item.putOption?.topBid === 0 || (putDiffPercent > ILLIQUID_OPTION_THRESHOLD && putDiff > 100)) {
                putIlliquid = true
            }
        } else {
            const callDiff = Math.abs((item.callOption?.topBid ?? 0) - (item.callOption?.topAsk ?? 0))
            const putDiff = Math.abs((item.putOption?.topBid ?? 0) - (item.putOption?.topAsk ?? 0))
            const callDiffPercent = (callDiff / callMid) * 100
            const putDiffPercent = (putDiff / putMid) * 100
            if (item.callOption?.topAsk === 0 || item.callOption?.topBid === 0 || (callDiffPercent > ILLIQUID_OPTION_THRESHOLD && callDiff > 100)) {
                callIlliquid = true
            }
            if (item.putOption?.topAsk === 0 || item.putOption?.topBid === 0 || (putDiffPercent > ILLIQUID_OPTION_THRESHOLD && putDiff > 100)) {
                putIlliquid = true
            }
        }

        if (item.callOption) {
            item = {
                ...item,
                callOption: {
                    ...item.callOption,
                    oiRank: rankCall,
                    oiRankChange: rankCall * ((item.callOption?.oiChanges?.oiChange?.changePercent || 0) / 100),
                    oiChangeScore: oiChangeScoreCall,
                    illiquid: callIlliquid
                }
            }
        }
        if (item.putOption) {
            item = {
                ...item,
                putOption: {
                    ...item.putOption,
                    oiRank: rankPut,
                    oiRankChange: rankPut * ((item.putOption?.oiChanges?.oiChange?.changePercent ?? 0) / 100),
                    oiChangeScore: oiChangeScorePut,
                    illiquid: putIlliquid
                }
            }
        }
        if (item.strikeCol.pcr >= maxAllowedPcrValue) {
            item = {
                ...item,
                strikeCol: {
                    ...item.strikeCol,
                    pcrStrength: 100
                }
            }
        } else {
            const percentage = (item.strikeCol.pcr / maxAllowedPcrValue) * 100
            item = {
                ...item,
                strikeCol: {
                    ...item.strikeCol,
                    pcrStrength: percentage
                }
            }
        }
        trade[i] = item
    }
    return trade
}

export const createStringDateFromStamp = (timeStamp: number, showDay: boolean = true, showMonth: boolean = true, showYear: boolean = false) => {
    const date = new Date(timeStamp)
    let day = date.getDate().toString()
    if (Number(day) < 10) day = '0' + day
    const month = shortMonthNames[date.getMonth()]
    const year = date.getFullYear()
    const currentDate = new Date()
    let result = ''
    if (showDay) {
        result += day + ' '
    }
    if (showMonth) {
        result += month
    }
    if (showYear || currentDate.getFullYear() !== year) {
        result += `, ${year}`
    }
    return result
}

export const createStringDateFromStampWithTime = (timeStamp: number) => {
    const date = new Date(timeStamp)
    const formatted = date.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    })
    return formatted.replace(',', '')
}
